import { BadgeEuro, Handshake, Scale, Flame, ArrowRight, Globe2 } from "lucide-react";
import { useLang } from "@/i18n";

const ICONS = [BadgeEuro, Handshake, Scale, Flame];

export default function WhyMe() {
  const { t } = useLang();
  return (
    <section id="pourquoi" className="relative py-24 sm:py-32" data-testid="why-me-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <p className="eyebrow" data-testid="why-me-eyebrow">{t.whyme.eyebrow}</p>
          <h2 className="mt-5 font-display text-3xl font-semibold tracking-tight text-[#3B322A] sm:text-4xl" data-testid="why-me-title">
            {t.whyme.title1}
            <span className="gold-gradient-text italic">{t.whyme.titleAccent}</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-[#5F5647]">
            {t.whyme.intro}
          </p>
          <p className="mt-6 flex items-start gap-3 text-base font-medium text-[#3B322A]" data-testid="why-me-remote-line">
            <Globe2 size={20} className="mt-0.5 shrink-0 text-[#A87C4F]" />
            <span className="text-[#3B322A]">
              {t.whyme.remoteLine}
            </span>
          </p>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2">
          {t.whyme.cards.map((a, i) => {
            const Icon = ICONS[i];
            return (
              <article
                key={a.testid}
                data-testid={a.testid}
                className="card-lux group flex items-start gap-6 rounded-md p-7"
              >
                <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-sm border transition-colors duration-300 ${i % 2 ? "border-[#C09A6B]/40 bg-[#C09A6B]/10 text-[#856237] group-hover:bg-[#C09A6B]/20" : "border-[#A87C4F]/40 bg-[#A87C4F]/10 text-[#856237] group-hover:bg-[#A87C4F]/20"}`}>
                  <Icon size={22} strokeWidth={1.6} />
                </div>
                <div>
                  <h3 className="font-display text-xl font-semibold leading-snug text-[#3B322A]">
                    {a.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#948678]">{a.description}</p>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href="#contact"
            data-testid="why-me-cta-button"
            className="btn-outline-gold inline-flex items-center gap-2 rounded-sm px-8 py-4 text-sm font-semibold uppercase tracking-[0.12em]"
          >
            {t.whyme.cta}
            <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
